export const BASE_URL = "https://api.roi-ace.leveldata.com/api/";
export const HOST = "https://roi.leveldata.com/";
